export const SECTIONS = {
    MANEUVER: 'maneuver-sat-info',
};
export const EL = {
    DATA: `${SECTIONS.MANEUVER}-data`,
    COLLAPSE: `${SECTIONS.MANEUVER}-collapse`,
};
